<template>
    <div class="bottom mt20">
        <div class="bottom_top">
            <div class="w1200">
                <ul>
                    <li>
                        <img src="/static/images/add_ewm_03.jpg" />
                        <b>物流唐山官方微信</b>
                        <span>微信扫一扫，关注ts560315获取最新唐山市物流行业资讯</span>
                    </li>
                    <!-- <li class="y_bottom_wb">
            <img src="/static/images/new_wblogo_03.jpg" />
            <b>物流唐山官方微博</b>
            <span>找车、找货、找仓储，找物流唐山！</span>
            <span class="y_wb_txt">
              <wb:follow-button uid="3959634030" type="red_1" width="136" height="24">
                <iframe
                  src="http://widget.weibo.com/relationship/followbutton.php?btn=red&amp;style=1&amp;uid=3959634030&amp;width=136&amp;height=24&amp;language=zh_cn"
                  width="136"
                  height="24"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                ></iframe>
              </wb:follow-button>
            </span>
                    </li>-->
                    <li class="y_border_none">
                        <img src="/static/images/new_qqq_03.jpg" />
                        <b>物流唐山客服微信</b>
                        <span>找车、找货、找仓储，找物流唐山！</span>
                        <!-- <span><a
                target="_blank"
                href="http://shang.qq.com/wpa/qunwpa?idkey=bad900063694b13c8843aa3e5e26aff52b2734015fcfcc7dab75fdde9abd4017"
              >
                <img
                  border="0"
                  src="http://pub.idqqimg.com/wpa/images/group.png"
                  alt="物流唐山客服群"
                  title="物流唐山客服群"
                >
              </a>
                        </span>-->
                    </li>
                </ul>
            </div>
        </div>
        <div class="w1200">
            <div class="bottom_menu">
                <router-link :to="{name:'index'}">首页</router-link>
                <span>|</span>
                <router-link :to="{name:'aboutus'}">关于我们</router-link>
                <span>|</span>
                <router-link :to="{name:'dynamic'}">本网动态</router-link>
                <span>|</span>
                <router-link :to="{name:'logisticsnews'}">热点新闻</router-link>
                <span>|</span>
                <router-link :to="{name:'proclamation'}">通知公告</router-link>
                <span>|</span>
                <router-link :to="{name:'version'}">版本迭代</router-link>
            </div>
            <div>免费客服热线：0315-5918519</div>
            <div>
                <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=1371062109&amp;site=qq&amp;menu=yes">
                    <img border="0" src="/static/images/QQT.gif" alt="点击这里给我发消息" title="点击这里给我发消息" style="vertical-align: -8px;" />
                </a>
            </div>
            <div>
                <span>7*24客服电话：19912348061</span>
                <span>纠错电话：0315-5918519</span>
                <span>电子邮件：3246884810@qq.com</span>
            </div>
            <div>
                <span>主办单位： 唐山成联数据科技有限公司</span>
            </div>
            <div>
                <span>
                    <a href="http://beian.miit.gov.cn/" target="_blank">冀ICP备11009155号-16</a>
                </span>
                <span>网站制度</span>
                <span>证照信息公示</span>
            </div>
            <div>
                <span>
                    <img src="/static/images/ba.png" />
                    冀公网安备 13024002000178号
                </span>
            </div>
            <div>
                <span>
                    <a
                        href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=911302937554531049-SAIC_SHOW_1000009113029375545310491606701400937&signData=MEQCINx/R/cwiXA1EPgUevU041e2LjtbcXWEe6wq+nTSh5TMAiCEaZcqNfvnC1K8+/RNY9KkNb1TxqFFRH9E5KzydA2q0w=="
                        target="_blank"
                    >
                        <img src="/static/images/lztb.png" />
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "homebottom",
};
</script>
<style scoped>
.bottom {
    background: #454545;
    text-align: center;
    color: #a8a8a8;
    line-height: 30px;
    padding: 40px 0 30px;
}
.bottom a {
    color: #999;
    cursor: pointer;
}
.bottom span {
    padding: 0 10px;
}
.bottom_top {
    border-bottom: 1px solid #626262;
    height: 103px;
}
.bottom_top ul {
    padding-left: 150px;
}
.bottom_top ul li {
    width: 31%;
    float: left;
    text-align: left;
    padding: 0 2% 0 8%;
    height: 62px;
    border-right: 1px solid #727272;
}

.bottom_top ul li:last-child {
    border: 0;
}
.bottom_top ul li img {
    float: left;
    margin-right: 20px;
}
.bottom_top ul li b {
    display: block;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
}
.bottom_top ul li span {
    padding: 0;
    line-height: 18px;
    display: block;
    margin-top: 5px;
}
.bottom_menu {
    height: 30px;
    padding: 17px 0;
    text-align: center;
}
.bottom_menu a {
    line-height: 30px;
}
.bottom_menu span {
    padding: 0 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/homeBottom.vue